// Names in the 'groups-finals' format: groups are letters (0 is 'A'), a knockout round has its own title.
export const groupName = (group) => String.fromCharCode(65 + group);

// 'Round 3', or in a knockout 'Semifinals' / 'Final'.
export const roundTitle = (round) => round.title || `Round ${round.roundId + 1}`;
